import {SxProps} from '@mui/material';

export const STYLES = {
  container: {
    minHeight: 380,

    '& .rdrMonths.rdrMonthsHorizontal': {
      justifyContent: 'center',
    },
  },
} as const satisfies SxProps;
